// Logic for cropper for agency profile
window.$(document).ready(function () {
  window.$('.upload-logo').click(function (click) {
    click.preventDefault();
    window.$('input.crop-logo').click();
  });
  window.$('input.crop-logo').change(function () {
    let modalHtml = window.$('#crop-image').clone();
    let inputParent = window.$(this).parent();
    let errorBox = window.$(this).siblings('.alert-box--error');
    let loader = window.$(this).siblings('.loader-wrap');
    let formData = new FormData();
    let logo = document.getElementById($(this).attr('id')).files[0];
    if (!logo.type.match('image.*')) {
      return false;
    }

    let type = $('#entity_type').val();

    errorBox.hide();
    loader.show();
    formData.append('logo', logo);
    formData.append('entity_type', type);
    formData.append('file_id', $('#file_id').val());

    axios.post('/ajax/logo/upload', formData,
      {
        headers: {'content-type': 'multipart/form-data'}
      })
      .then((response) => {
        loader.hide();
        window.$('small', inputParent).removeClass('text-danger');
        let cropper = null;

        if (type == 'agency_logo') {
          $('#file_id').val(response.data.file_id);
          $('.edit-crop').attr('data-resource-id', response.data.file_id);
          window.$('#image-to-crop').attr('src', response.data.public_path);
        } else {
          window.$('#image-to-crop').attr('src', '/' + response.data['original_image']);
        }

        window.$('#crop-image').modal({
          backdrop: 'static'
        });

        window.$('#crop-image').on('shown.bs.modal', function () {
          if (cropper) {
            cropper.destroy();
          }
          let image = document.getElementById('image-to-crop');
          cropper = new Cropper(image, {
            viewMode: 2,
            autoCropArea: 1,
            aspectRatio: 1,
            autoCrop: true,
            restore: false,
            minCanvasWidth: 700,
            crop: function (cropDetails) {
              if (Math.ceil(cropDetails.detail.width) < 700 || Math.ceil(cropDetails.detail.height) < 700) {
                cropper.setData({width: 700, height: 700});
              }
            },
            zoom: function (e) {
              if (e.detail.ratio > 1) {
                e.preventDefault();
                cropper.zoomTo(0.99);
              }
            },
          });
          window.$('.rotate-right').click(function (event) {
            event.preventDefault();
            cropper.rotate(45);
          });
          window.$('.rotate-left').click(function (event) {
            event.preventDefault();
            cropper.rotate(-45);
          });
          window.$('.zoom-in').click(function (event) {
            event.preventDefault();
            cropper.zoom(0.1);
          });
          window.$('.zoom-out').click(function (event) {
            event.preventDefault();
            cropper.zoom(-0.1);
          });
          window.$('.cancel-crop').click(function (event) {
            event.preventDefault();
            cropper.reset();
          });
          window.$('.save-crop').click(function (click) {
            click.preventDefault();
            let cropInfo = cropper.getData(true);
            cropInfo.key = response.data.id;
            cropInfo.image_extension = response.data.image_extension;
            cropInfo.backup = response.data.backup;
            cropInfo.file_id = $('#file_id').val();

            // apply crop changes and set
            axios.post('/ajax/logo/transform', cropInfo)
              .then((transformResponse) => {
                response.data.logo = transformResponse.data.cropPublicPath + "?" + new Date().getTime() + Math.floor(Math.random() * 100);
                cropper.destroy();
                window.$('#crop-image').modal('hide');
              });
          });
        });
        window.$('#crop-image').on('hidden.bs.modal', () => {
          window.$('#crop-image').after(modalHtml).remove();

          if ($('#entity_type').val() == 'agency_logo') {
            $('.image-cell').css('display', 'none');
            $('#cover_image').attr('src', response.data.logo);

            if(!$('#cover_image').data('cancel-display-block')) {
              $('#cover_image').css('display', 'block');
            }

            $('.owner-logo img').attr('src', response.data.logo);

            return;
          }

          window.$('.image-cell', inputParent).css('background', "url('/" + response.data.logo + "') no-repeat center center / 100% 100%");
          window.$('.owner-logo img').attr('src', '/' + response.data.logo);
        });
      }).catch(() => {
        loader.hide();
        window.$('input.crop-logo').val('');
        errorBox.show().find('.alert-box-inner').text('Error in file uploading. File must be min 700x700px, JPG, PNG');
      });
  });
  window.$('input.ajax-load.logo').change(function () {
    let inputParent = window.$(this).parent();
    let formData = new FormData();
    let image = document.getElementById('image').files[0];
    if (!image.type.match('image.*')) {
      return false;
    }
    formData.append('image', image);
    axios.post('/ajax/image/upload', formData,
      {
        headers: {'content-type': 'multipart/form-data'}
      })
      .then((response) => {
        window.$('.image-cell', inputParent).css('background', "url('/" + response.data.image + "') no-repeat center center / 100% 100%");
      });
  });
  window.$('button.default-image').click(function (click) {
    click.preventDefault();
    window.$('.image-cell', $(this).parent()).css('background', $(this).data('default-image'));
    let indicatorInputName = window.$('.upload-logo', $(this).parent()).data('indicator-input-name');
    window.$('input[name=' + indicatorInputName + ']').val('');
    window.$('input[type=file]', $(this).parent()).val('');
  });
});